export const state = {
  figment: getSavedState('figment'),
}

export const mutations = {
  SET_FIGMENT(state, newValue) {
    state.figment = newValue
    saveState('figment', newValue)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  selectedFigment(state) {
    return state.figment
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    dispatch('validate')
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    return null
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
